import { createI18n } from "vue-i18n";
import { DEFAULT_LANGUAGE, normalizeLanguage } from "@/constants/languages";

const locales = ["ko", "ar", "cz", "de", "en", "fr", "it", "ja", "kz", "pt", "sk","sv"];
const messages = locales.reduce((accumulator, locale) => {
    accumulator[locale] = {
        ...require(`@/i18n/${locale}/menu.json`),
        ...require(`@/i18n/${locale}/label.json`),
        ...require(`@/i18n/${locale}/message.json`),
    };
    return accumulator;
}, {});

// localStorage에서 언어 설정 가져오기 (store와 동기화)
const savedLanguage = normalizeLanguage(localStorage.getItem("language"));

export const i18n = createI18n({
    locale: savedLanguage,
    fallbackLocale: DEFAULT_LANGUAGE,
    messages,
    legacy: false,
});
